import { Typography } from "@mui/material";

import { formatMatchStart } from "../data/formatMatchStart";

interface MatchTimeProps {
  date?: Date;
  kickoff?: string;
}

export function MatchTime({ date, kickoff }: MatchTimeProps): JSX.Element {
  const value = formatMatchStart(kickoff) ?? date?.toDateString();

  if (!value) return <span />;

  return (
    <Typography variant="body2" color="text.secondary">
      {value}
    </Typography>
  );
}
